import { useWealthOverview } from '@egw/api'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { InformationCircleIcon } from '@heroicons/react/24/solid'
import { type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { Navigate } from 'react-router'
import { InvestmentAccountNotRegistered } from '../investment-account-not-registered'

export const InvestmentsWrapper: FC = () => {
  const { t } = useTranslation('features-investment')
  const { data, isLoading, isError } = useWealthOverview()

  const personalPortfolioAccounts = data?.personalPortfolio?.accounts ?? []

  return (
    <>
      {isError ? (
        <div className="egw-container">
          <InformationCircleIcon className="w-12 h-12 fill-red-500 mb-4" />
          <p className="text-error text-2xl font-light mb-10">{t('common.generic_error')}</p>
          <p className="text-body text-xl">{t('activity.error')}</p>
        </div>
      ) : null}

      {isLoading ? (
        <div className="egw-container">
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        </div>
      ) : null}

      {!isLoading && personalPortfolioAccounts.length > 1 ? (
        <Navigate replace to={WEALTH_ROUTES.INVESTMENTS_OVERVIEW.path} />
      ) : null}

      {!isLoading && personalPortfolioAccounts.length === 1 ? (
        <Navigate
          replace
          to={WEALTH_ROUTES.INVESTMENTS_ACCOUNT.path.replace(':alias', personalPortfolioAccounts[0]?.alias.toString())}
        />
      ) : null}

      {!isLoading && personalPortfolioAccounts.length < 1 ? <InvestmentAccountNotRegistered /> : null}
    </>
  )
}
